<template>
  <div class="app-main">
        <h4 class="land_title">修改密码</h4>
        <van-form ref="domform" @submit="onlogin()">
          <van-field v-model="from.empNo" name="手机号" readonly show-error type="tel" placeholder="请输入您的工号" :rules="fromrules.empNo" />
          <van-field type="password" v-model="from.oldPwd" center clearable :rules="fromrules.oldPwd" placeholder="请输入您的旧密码"></van-field>
          <van-field type="password" v-model="from.pwd" center clearable :rules="fromrules.pwd" placeholder="请输入您的新密码"></van-field>
          <div style="margin: 16px;">
            <van-button round block type="info" class="butland" native-type="submit">修改密码</van-button>
          </div>
        </van-form>
  </div>
</template>

<script>
import md5 from 'blueimp-md5'
import { agentUserUpdatePassword } from '@/api/poster'

export default {
  name: 'PosterLand',
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      from:{
        empNo: '',
        oldPwd: '',
        pwd: ''
      },
      fromrules:{
        empNo: [{ required: true, trigger: 'onChange' }],
        oldPwd: [{ pattern:/^[a-zA-Z0-9]{8,30}$/, message: '密码不能是中文特殊字符,且至少8位以上' }],
        pwd: [{ pattern:/^[a-zA-Z0-9]{8,30}$/, message: '密码不能是中文特殊字符,且至少8位以上' }]
      }
      
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.from.empNo = this.$route.query.username
  },
  activated() {},
  methods: {
    async onlogin () {
      try{
        let parmes ={
          empNo: this.from.empNo,
          oldPwd: md5(this.from.oldPwd),
          pwd: md5(this.from.pwd)
        }
        let res = await agentUserUpdatePassword(parmes)
        if(res.code===0){
            this.$router.push({ path: '/perfect-information',query:{
              id:res.id,
              token: this.$route.query.token
            } })
          }else if(res.code===1){
            this.$router.push({ path: '/poster-deal',query:{
              id:res.id,
              token: this.$route.query.token
            } })
          }
      } catch(e) {
        this.$notify({ type: 'danger', message: e.message })
      }

    }
  }
}
</script>
<style lang='scss' scoped>
.app-main {
  padding: 0 px2rem(33);
}
.land_title {
  margin-top: px2rem(140);
  font-size: px2rem(46);
  font-weight: 500;
  color: #000;
  line-height: px2rem(69);
}
.dispflex {
  display: flex;
  > div:nth-child(1) {
    > ::after {
      content: '';
      width: 0px;
      height: 0px;
      border-top: 6px solid #000;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-bottom: 6px solid transparent;
      position: absolute;
      top: 12px;
      right: 0;
    }
    width: 90px;
  }
  .van-cell::after {
    display: none;
  }
}
.sendverification{
  font-size: px2rem(34);
  color: #333;
  border: none;
}
.butland{
  height: px2rem(120);
  background: linear-gradient(to right, #FF6C61 , #DB0003);;
  border-radius:  px2rem(60);
  border-color: #EDEEF2;
}
</style>
